<template>
	<div class="lang-wrapper py-5 [--header-offset:50px] lg:[--header-offset:90px]" :class="[{ mobile: isMobile }, 'min-h-[calc(100vh-var(--offset))] supports-[height:100dvh]:min-h-[calc(100dvh-var(--offset))]']"
        :style="`--offset: calc(${mainStore.redeemBannerHeight}px + var(--header-offset) + ${mainStore.topbarMenuHeight}px);`">
		<div class="container">
            <button type="button" @click="onBack" :aria-label="$t('back')" class="flex items-center md:hidden lang-text">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" class="w-4 mr-3">
                    <path fill="currentColor" fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
                </svg>
                <div>{{$t("region_and_language")}}</div>
            </button>
            <div class="w-full flex flex-wrap px-[26px] md:px-[20px] pb-5 md:py-5 md:justify-center">
                <div v-if="['jw8','champ191','wic11'].includes(config.public.MERCHANT)">
                    <div v-for="l in langList" :key="l.langCode">
                        <Collapse v-if="l.currencies.length > 1">
                            <template #head="{opened}">
                                <button type="button" class="lang_text_collapse" :class="opened ? 'active' : ''" :aria-label="l.name">
                                    <div class="content">
                                        <img class="flag" :src="$resolveUrl(`{d}flags/${l.langCode}.webp`)" :alt="`country_${l.langCode}`" >
                                        <div class="text">{{l.name}}</div>
                                    </div>
                                    <div class="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 10">
                                            <path id="Path_94706" data-name="Path 94706" d="M172.667,298.667l6,6,6-6,2,2-8,8-8-8Z" transform="translate(-170.667 -298.666)"/>
                                        </svg>
                                    </div>
                                </button>
                            </template>
                            <template #body>
                                <div>
                                    <button v-for="c in l.currencies" :key="c.locale" @click="changeCurrency(c)" type="button" class="btn_currency" :class="c.locale == locale ? 'active' : ''" :aria-label="c.currency_display">{{c.currency_display}}&#32;&#40;{{c.name}}&#41;</button>
                                </div>
                            </template>
                        </Collapse>
                    </div>
                    <div v-for="l in langList" :key="l.langCode">
                        <button v-if="l.currencies.length == 1" :aria-label="l.name" type="button" class="lang_text_collapse" :class="l.currencies[0]['locale'] == locale ? 'highlight' : ''" @click="changeCurrency(l.currencies[0])">
                            <div class="content">
                                <img class="flag" :src="$resolveUrl(`{d}flags/${l.langCode}.webp`)" :alt="`country_${l.langCode}`" >
                                <div class="text">{{l.name}}&#32;&#40;{{l.currencies[0]['name']}}&#41;</div>
                            </div>
                        </button>
                    </div>
                </div>
                
				<div v-else>
                    <div v-for="(languages, countryCode) in countryLanguages" :key="countryCode" class="language-country-item md:p-[10px] mt-[24px] md:mt-0 mr-5">
                        <div class="flex items-center mt-[15px] md:mt-2">
                            <img v-if="config.public.MERCHANT == 'goldbet888' && countryCode == 'kh'" class="w-8 md:w-[30px] mr-7 md:mr-2" :src="$pub('/img/icons/usdt.png')" :alt="`country_${countryCode}`" >
                            <img v-else class="w-8 md:w-[30px] mr-7 md:mr-2" :src="$resolveUrl(`{d}flags/${countryCode}.webp`)" :alt="`country_${countryCode}`" >
                            <div v-for="(lang, langIndex) in languages" :key="lang.code" class="language-country-lang-item flex items-center">
                                <button type="button" class="font-normal text-xs md:text-sm" :class="lang.code == locale ? 'active' : ''"  @click="changeLang(lang)" :aria-label="lang.name">{{lang.name}}</button>
                                <div v-if="langIndex != languages.length - 1" class="h-[20px] w-[1px] bg-current mx-2 bg-c-vgs"></div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
		</div>
	</div>
</template>

<script setup>
const config = useRuntimeConfig()
const { locale} = useI18n()
const { isMobile } = useDevice()
const dashboardStore = useDashboardStore()
const countryStore = useCountryStore()
const mainStore = useMainStore()
const { $resolveUrl } = useNuxtApp()
const countryLanguages = computed(() => {
    if (!dashboardStore.ready) return {}
    let langs = {}
    Object.values(dashboardStore.data.user_language).forEach(country => {
        Object.keys(country).forEach(countryCode => {
            let formattedCountryCode = countryCode.toLowerCase()
            langs[formattedCountryCode] = []
            Object.keys(country[countryCode]).forEach(langCode => {
                langs[formattedCountryCode].push({
                    code: `${langCode}-${formattedCountryCode}`,
                    name: country[countryCode][langCode],
                    countryCode: formattedCountryCode
                })
            })

        })    
    })
    return langs
})

const router = useRouter()
const localePath = useLocalePath()
const switchLocalePath = useSwitchLocalePath()
const changeLang = async(lang) => {
    const last = router.options.history.state.back || '/'
    let path = last.replace(`${locale.value}`,'').replace('//','/')
    await router.replace(switchLocalePath(lang.code))
    router.replace(localePath(path))
}

const changeCurrency = async(currency) => {
    const last = router.options.history.state.back || '/'
    let path = last.replace(`${locale.value}`,'').replace('//','/')
    await router.replace(switchLocalePath(currency.locale))
    router.replace(localePath(path))
}

const onBack = () => {
    if (!window.history.state.back) {
        router.replace(localePath('/'))
    }
    else {
        router.back()
    }
}

const langList = computed(() =>{
	if (dashboardStore.ready && countryStore.ready) {
		let items = []

		// compile languages from dashboard
		Object.values(dashboardStore.data.user_language).forEach((l) => {
			for (let countryCode in l) {
				for (let languageCode in l[countryCode]) {
					const matchedLanguage = items.find(il => il.langCode == languageCode)
					if (!matchedLanguage) {
						items.push({
							name: l[countryCode][languageCode],
							langCode: languageCode,
							countryCode: [countryCode.toLowerCase()],
							currencies: [],
							
						})
					}
					else {
						matchedLanguage.countryCode.push(countryCode.toLowerCase())
					}
				}
			}
		})
		
		// assign currencies from countryStore
		items.forEach(l => {
			l.countryCode.forEach(c => {
				const matchedCurrency = countryStore.data.find(cd => cd.abr.toLowerCase() == c)
				if (matchedCurrency) {
					l.currencies.push({
						name: matchedCurrency.currency,
						currency_display: matchedCurrency.currency_display,
						locale: `${l.langCode}-${c}`
					})
				}
			})
			// delete l.langCode
			delete l.countryCode
		})

		// remove any language that has no currency
		items = items.filter(l => l.currencies.length > 0)
		return items
	}
	return []
})

onMounted(() => {
    nextTick(() => {
        window.scrollTo(0, 0);
    })
})
</script>
